<template>
  <div
    class="action-menu"
    v-show="d_open"
  >
    <div
      v-for="(menu, index) in c_menuItems"
      :key="index"
      class="action-menu-item"
      @click="m_select(menu)"
    >
      <div class="menu-grp">
        <b-button
          class="btn-link w-100 p-0"
          style="border: none;"
          variant="link"
          :title="menu.title"
        >
          <fa-icon v-if="menu.icon" :icon="menu.icon" />
          <span v-else-if="menu.emoji">{{ menu.emoji }}</span>
          <span>{{ menu.label }}</span>
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
//import clickOutside from "@/utils/click-outside";

export default {
  name: "ActionMenu",
  props: {
    p_appEntKey: String,
	p_menuItems: Array,
	p_open:Boolean,
  },

  data() {
    return {
      d_open: false,
    };
  },
  computed: {
    c_menuItems() {
      return this.p_menuItems|| [];
    },
  },

  methods: {
    m_toggle() {
      this.d_open = !this.d_open;
    },

    m_close() {
      this.d_open = false;
    },

    m_select(menu) {
      if (menu.onClick) menu.onClick();
      this.$emit("menuSelect", menu);
    },
  },
watch: {
  p_open(nv){this.d_open=nv;},
  },
};
</script>
<style scoped>
.action-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  padding: 6px 0;
  min-width: 200px;
  z-index: 50;
}
.action-menu-item {
  padding: 8px 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.action-menu-item:last-child {
  border-bottom: none; 
}
.action-menu-item:hover {
  background1: #f5f5f5;
  background: rgba(0,0,0,0.04);
}
.menu-grp {
  width: 100%;
}


</style>
/*
	 <button class="action-menu-trigger" @click="m_toggle">
	...
	</button>
    <ul v-show="d_open" class="action-menu-list">
      <li
        v-for="(item, idx) in c_menuItems"
        :key="idx"
        class="action-menu-item"
        @click="m_handleClick(item)"
      >
        <span v-if="item.icon" class="icon">{{ item.icon }}</span>
        <span>{{ item.label }}</span>
      </li>
    </ul>
*/